import React from 'react';
import { NotificationsScreen } from 'fitbeat.react-native-components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';

export const NotificationsScreenContainer = (props) => (
    <GridLayoutWithRightContent {...props}>
        <NotificationsScreen {...props}/>
    </GridLayoutWithRightContent>
);
